// extracted by mini-css-extract-plugin
export default {"buttonBadge":"premium-banner_buttonBadge__mzOqa"};